import { useTranslation } from '../../i18n'
import './Features.css'

function Features() {
  const { t } = useTranslation()

  const features = [
    { icon: '🎤', titleKey: 'feature1Title', descKey: 'feature1Desc' },
    { icon: '💻', titleKey: 'feature2Title', descKey: 'feature2Desc' },
    { icon: '🧠', titleKey: 'feature3Title', descKey: 'feature3Desc' },
    { icon: '💡', titleKey: 'feature4Title', descKey: 'feature4Desc' },
    { icon: '🔍', titleKey: 'feature5Title', descKey: 'feature5Desc' },
    { icon: '🔀', titleKey: 'feature6Title', descKey: 'feature6Desc' },
    { icon: '🔒', titleKey: 'feature7Title', descKey: 'feature7Desc' },
    { icon: '🖥️', titleKey: 'feature8Title', descKey: 'feature8Desc' },
  ] as const

  return (
    <section id="features" className="section section-gray" aria-label="Features">
      <div className="container">
        <div className="section-title">
          <h2>{t('featuresTitle')}</h2>
          <p>{t('featuresSubtitle')}</p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <article key={index} className="feature-card card">
              <div className="feature-icon" role="img" aria-hidden="true">{feature.icon}</div>
              <h3 className="feature-title">{t(feature.titleKey)}</h3>
              <p className="feature-description">{t(feature.descKey)}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Features
